export default __webpack_public_path__ + "static/media/copylink.5b701344.svg";